module.exports = __webpack_public_path__ + "img/highSpeedRail-2.fa1183d3.jpg";